/// <reference types="../global.d.ts" />

export function reachGoal(metrikaId: string, goalName: string) {
  window?.ym?.(metrikaId, 'reachGoal', goalName)
}
